export const SuccessfulVerificationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 357 231"
        >
            <g filter="url(#a)" opacity=".05">
                <rect
                    width="174.394"
                    height="104.637"
                    fill="#394855"
                    rx="9"
                    transform="matrix(.86603 -.5 .86603 .5 70.973 132.795)"
                />
            </g>
            <path
                fill="#D9D9D9"
                d="M23.649 121.275c-1.33-.896-2.06-2.038-2.06-3.219v-2.361l8.124-4.965 12.194-7.04 24.388-14.08 48.777-28.161 90.624-52.323c3.827-2.209 10.031-2.209 13.857 0L322.76 68.713c3.826 2.21 3.826 5.79 0 8L143.243 180.357c-4.783 2.762-12.538 2.762-17.321 0l-101.92-58.843-.353-.239Z"
            />
            <path
                fill="#fff"
                stroke="#D9D9D9"
                d="M25.268 119.9c-4.07-2.35-4.07-6.161 0-8.511L204.766 7.756c4.071-2.35 10.671-2.35 14.742 0L320.963 66.33c4.071 2.35 4.071 6.161 0 8.511L141.466 178.475c-4.071 2.35-10.672 2.35-14.743 0L25.269 119.9Z"
            />
            <path
                fill="#394855"
                d="M64.255 116.333c-1.774 1.089-1.774 2.787 0 3.876l16.818 10.322-17.772-10.26c-1.914-1.105-1.914-2.896 0-4l17.771-10.261-16.817 10.323Zm37.427-22.221 17.913-9.728c1.872-1.017 4.786-1.025 6.676-.02l12.733 6.774-12.623-7.287c-1.913-1.105-5.015-1.105-6.928 0l-17.771 10.26Zm68.23 14.871 11.765 7.371c1.728 1.083 1.728 2.751 0 3.834l-11.766 7.37 12.623-7.287c1.913-1.105 1.913-2.896 0-4l-12.622-7.288Zm-30.908 36.42-12.733 6.774c-1.89 1.006-4.804.997-6.676-.019l-17.914-9.728 17.772 10.26c1.913 1.105 5.015 1.105 6.928 0l12.623-7.287Zm-22.538-20.484c-3.807 2.198-5.947 5.18-5.947 8.289s2.14 6.091 5.947 8.289c1.839 1.061 4.352 1.646 6.85 1.231 4.77-.793 13.54-3.056 24.736-9.52 11.196-6.464 15.116-11.528 16.489-14.281.719-1.443-.293-2.894-2.132-3.955-3.807-2.199-8.972-3.434-14.357-3.434s-10.549 1.235-14.357 3.434l-17.229 9.947Zm13.86-15.729c-.783-2.274-2.717-4.363-5.557-6.003-3.808-2.198-8.972-3.433-14.357-3.433s-10.55 1.235-14.357 3.433c-2.84 1.64-4.774 3.729-5.557 6.003-.783 2.273-.381 4.63 1.155 6.773 1.537 2.142 4.14 3.972 7.479 5.26 3.339 1.289 7.264 1.976 11.28 1.976 4.016 0 7.941-.687 11.28-1.976 3.339-1.288 5.942-3.118 7.479-5.26 1.536-2.142 1.938-4.5 1.155-6.773Z"
                opacity=".3"
            />
            <path
                fill="#394855"
                d="M145.832 71.65c-2.079-1.2-2.079-3.147 0-4.348l56.485-32.612c2.08-1.2 5.452-1.2 7.532 0s2.08 3.148 0 4.348L153.364 71.65c-2.08 1.2-5.452 1.2-7.532 0Zm17.887 10.327c-2.079-1.2-2.079-3.147 0-4.348l72.49-41.852c2.079-1.2 5.451-1.2 7.531 0s2.08 3.148 0 4.348l-72.489 41.852c-2.08 1.2-5.452 1.2-7.532 0ZM181.5 92.243c-2.079-1.2-2.079-3.147 0-4.348l41.423-23.915c2.08-1.201 5.452-1.201 7.531 0 2.08 1.2 2.08 3.147 0 4.348l-41.422 23.915c-2.08 1.2-5.452 1.2-7.532 0Z"
                opacity=".1"
            />
            <g filter="url(#b)" opacity=".4">
                <path
                    fill="#89D243"
                    d="M266.352 63.755c-1.326-2.646 2.92-5.097 7.502-4.332 3.196.534 6.539-.52 7.489-2.36 1.363-2.64 7.23-3.377 10.368-1.303 2.189 1.447 5.988 1.603 8.511.351 3.618-1.795 9.243-.583 9.941 2.141.487 1.9 3.536 3.218 6.831 2.952 4.724-.38 8.322 2.394 6.358 4.904-1.37 1.75-.039 3.811 2.982 4.616 4.331 1.154 4.76 4.612.757 6.11-2.792 1.045-3.601 3.194-1.814 4.814 2.563 2.323-.314 5.365-5.085 5.376-3.326.008-6.02 1.563-6.033 3.484-.019 2.754-5.289 4.415-9.313 2.935-2.805-1.031-6.527-.564-8.337 1.048-2.595 2.31-8.584 2.063-10.583-.437-1.394-1.744-4.963-2.513-7.995-1.722-4.347 1.134-9.154-.943-8.494-3.671.461-1.902-1.822-3.663-5.113-3.944-4.719-.403-6.817-3.65-3.708-5.74 2.169-1.456 1.897-3.65-.609-4.913-3.592-1.812-2.316-5.2 2.256-5.986 3.188-.548 5.014-2.478 4.089-4.323Z"
                />
            </g>
            <path
                fill="#89D243"
                d="M262.192 53.546c-1.452-2.898 3.197-5.582 8.215-4.744l.847.142c3.5.584 7.161-.57 8.201-2.586l.252-.487c1.492-2.891 7.917-3.698 11.353-1.426l.58.383c2.397 1.584 6.558 1.756 9.32.385l.669-.332c3.962-1.966 10.122-.64 10.886 2.344l.129.504c.533 2.08 3.873 3.524 7.48 3.233l.874-.07c5.174-.418 9.114 2.621 6.963 5.37l-.363.463c-1.501 1.917-.043 4.174 3.265 5.055l.801.213c4.743 1.264 5.212 5.05.828 6.691l-.74.277c-3.056 1.144-3.943 3.498-1.986 5.272l.474.429c2.807 2.544-.344 5.875-5.568 5.887l-.882.003c-3.643.008-6.593 1.71-6.607 3.814l-.004.51c-.02 3.015-5.791 4.835-10.197 3.214l-.744-.273c-3.072-1.13-7.148-.618-9.13 1.146l-.48.428c-2.842 2.53-9.4 2.26-11.589-.48l-.37-.461c-1.526-1.91-5.434-2.752-8.754-1.886l-.804.21c-4.76 1.242-10.024-1.033-9.301-4.02l.122-.504c.504-2.083-1.996-4.011-5.6-4.319l-.872-.074c-5.168-.441-7.466-3.998-4.06-6.285l.575-.386c2.374-1.596 2.077-3.998-.667-5.381l-.664-.335c-3.935-1.984-2.537-5.694 2.47-6.555l.845-.145c3.491-.601 5.49-2.715 4.478-4.735l-.245-.49Z"
            />
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M285.124 70.718c0 1.172 1.645 2.122 3.674 2.122h7.295c.274 0 .542-.018.799-.05.198.032.406.05.622.05 1.245 0 2.253-.583 2.253-1.301V56.117c0-.718-1.008-1.3-2.253-1.3-1.244 0-2.253.582-2.253 1.3v12.217h-6.463c-2.029 0-3.674.95-3.674 2.121v.263Z"
                clipRule="evenodd"
            />
            <defs>
                <filter
                    id="a"
                    width="328.517"
                    height="230.243"
                    x="27.539"
                    y=".234"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur result="effect1_foregroundBlur_869_900" stdDeviation="24" />
                </filter>
                <filter
                    id="b"
                    width="83.921"
                    height="53.524"
                    x="251.932"
                    y="48.562"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur result="effect1_foregroundBlur_869_900" stdDeviation="3" />
                </filter>
            </defs>
        </svg>
    );
};
